import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./YouTubePreview.css";

interface YouTubePreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
	thumbnailFile?: ContentFileDto;
}

export const YouTubePreview: FC<YouTubePreviewProps> = ({
	companyName,
	content,
	files,
	thumbnailFile,
}) => {
	const initials = companyName
		.split(" ")
		.map((part) => part[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();

	return (
		<div className="yt-preview" role="img" aria-label="YouTube Shorts preview">
			<div className="yt-preview__frame">
				<div className="yt-preview__media">
					<PreviewMedia
						files={files}
						aspectRatio="9:16"
						posterUrl={thumbnailFile?.url}
					/>

					<div className="yt-preview__overlay" aria-hidden="true">
						<div className="yt-preview__sidebar">
							<div className="yt-preview__profile">
								<div className="yt-preview__avatar">{initials}</div>
							</div>
							<button
								type="button"
								className="yt-preview__action"
								tabIndex={-1}
								aria-hidden="true"
							>
								<Icon name="thumb_up" size={24} />
							</button>
							<button
								type="button"
								className="yt-preview__action"
								tabIndex={-1}
								aria-hidden="true"
							>
								<Icon name="thumb_down" size={24} />
							</button>
							<button
								type="button"
								className="yt-preview__action"
								tabIndex={-1}
								aria-hidden="true"
							>
								<Icon name="chat_bubble" size={24} />
							</button>
							<button
								type="button"
								className="yt-preview__action"
								tabIndex={-1}
								aria-hidden="true"
							>
								<Icon name="share" size={24} />
							</button>
						</div>

						<div className="yt-preview__footer">
							<div className="yt-preview__channel">{companyName}</div>
							{content.trim().length > 0 && (
								<p className="yt-preview__caption">{content}</p>
							)}
							<div className="yt-preview__shorts-badge">#Shorts</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
